import { render } from "./DocumentPicker.vue?vue&type=template&id=45bed78a"
import script from "./DocumentPicker.vue?vue&type=script&lang=js"
export * from "./DocumentPicker.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/stages_admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__